/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  landlords: [],
  error: '',
};

const getters = {
  landlords: state => state.landlords,
  error: state => state.error,
};

const actions = {
  shared({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/products/${payload.productId}/shared`, {
      amount: payload.amount,
      share_to_landlord: payload.landlordId,
    })
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response.data.error);
      });
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/products/${payload.productId}/shared`, {
      body: {
        share_to_landlord: payload.landlordId,
      },
    })
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  edit({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/products/${payload.productId}/shared`, {
      amount: payload.amount,
      share_to_landlord: payload.landlordId,
    })
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response.data.error);
      });
  },
};

const mutations = {
  [mTypes.DATA_ERROR](state, response) {
    state.error = response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/products/landlords.js